/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.email', []);
